import { render, staticRenderFns } from "./ErrorAlert.vue?vue&type=template&id=b213c75c&"
import script from "./ErrorAlert.vue?vue&type=script&lang=ts&"
export * from "./ErrorAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMessages } from 'vuetify/lib/components/VMessages';
installComponents(component, {VAlert,VExpandTransition,VHover,VIcon,VMessages})
